module.exports = __webpack_public_path__ + "media/images/application/template/button-paypal-7f1feea7cb1ce0a11222ec28822768c0.png";